import { API } from "utils";

export const saveProductSuggestion = async ({ id, data }) => {
  try {
    const response = await API().post(`api/stats/track/${id}/product`, data);
    return { success: true, payload: response.data };
  } catch (e) {
    return { success: false, payload: [], error: e };
  }
};
